import api from "./api";

class ComunidadService {
  async getAllComunidades() {
    return await api
      .get("/comunidades/list")
      .then((response) => {
        return { status: response.status, data: response.data };
      })
      .catch(function (error) {
        return { status: error.response.status, data: error.response.data };
      });
  }
}

export default new ComunidadService();
